/* unplugin-vue-components disabled */import script from "./certification.vue?vue&type=script&setup=true&lang=js"
export * from "./certification.vue?vue&type=script&setup=true&lang=js"

import "./certification.vue?vue&type=style&index=0&id=9ddeb18e&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ddeb18e"]])

export default __exports__